export const PAGINATION_LIMITS = {
  DEFAULT: 100,
};